module.exports = __webpack_public_path__ + "img/collection-engagementRingsRedgold@2x.f639734.webp";